import Phaser from 'phaser';

import AwaitLoaderPlugin from 'phaser3-rex-plugins/plugins/awaitloader-plugin.js';
import { HousePreviewScene } from './game/main';
// import { HouseDownloadWrapperScene } from './game/download_banners';

const scene = [HousePreviewScene];
// const scene = [HouseDownloadWrapperScene];
Phaser.Display.Canvas.CanvasPool.disableSmoothing();
const small = window.innerWidth < 600;
let canvas = null;
const scale = {
  mode: Phaser.Scale.FIT,
  autoCenter: Phaser.Scale.CENTER_BOTH,
  // width: 1920,
  // height: 1080,
  width: small ? 508 : 1920,
  height: small ? window.innerHeight : 1080,
};
if (small) {
  const cvs = document.createElement('canvas');
  cvs.id = 'my-canvas-game';
  document.body.appendChild(cvs);
  canvas = document.getElementById('my-canvas-game');
  canvas.getContext('2d').imageSmoothingEnabled = false;
  delete scale.mode;
  delete scale.autoCenter;
}

new Phaser.Game({
  backgroundColor: 0xffffff,
  canvas,
  type: small ? Phaser.CANVAS : Phaser.WEBGL,
  scene,
  scale,
  render: {
    antialias: true,
    antialiasGL: true,
  },
  roundPixels: true,
  pixelArt: false,
  fps: 60,
  autoFocus: true,
  plugins: {
    global: [
      {
        key: 'rexAwaitLoader',
        plugin: AwaitLoaderPlugin,
        start: true,
      },
    ],
  },
});

// Phaser.Display.Canvas.CanvasInterpolation.setBicubic(game.canvas);

// Phaser.Display.Canvas.Smoothing.disable(game.canvas.getContext(`2d`));
// console.log(Phaser.Display.Canvas.Smoothing.isEnabled(game.canvas.getContext(`2d`)));
